import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;
  const options = state.data.createdBy;
  if (isEmpty(profile)) {
    return null;
  }
  if (isEmpty(options)) {
    return null;
  }

  const createdBy = options[profile.createdBy];

  if (createdBy) {
    return createdBy;
  } else {
    return null;
  }
};
//VERIFY IF THE JWT IS SET
const getProfileCreatedBy = createSelector(getData, createdBy => createdBy);
export default getProfileCreatedBy;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getProfileCreatedBy.js